import { Badge, BadgeVariation } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { RoleKeywordScoreType } from "@oysterhr/schema"

const mapKeywordScoreToVariation: Record<
  RoleKeywordScoreType,
  Extract<BadgeVariation, "success" | "warning" | "gray">
> = {
  [RoleKeywordScoreType.High]: "success",
  [RoleKeywordScoreType.Medium]: "warning",
  [RoleKeywordScoreType.Low]: "gray",
} as const

export const KeywordScoreBadge = ({
  keywordScore,
}: {
  keywordScore?: RoleKeywordScoreType | null
}) => {
  const { t } = useTranslation("salary_insights_tool/JobRoleSelect")

  if (!keywordScore) return null
  return (
    <Badge variation={mapKeywordScoreToVariation[keywordScore]} isOutline>
      {t(`keywordScore.${keywordScore}`)}
    </Badge>
  )
}
